<template>
    <div>
        <nav class="level is-mobile"   >
            <div class="level-left">
                <div class="level-item" v-if="showTitleDisplay">
                    <h1 class="title" v-if="showTitleDisplay"
                           :style= "  getColorTitle "   >
                   <template  v-if="showIcon">
                       <b-icon
                               :icon="iconToShow"
                               size="is-small" />
                   </template>
 
                   {{titleDisplay}}  {{addTitleDisable}} </h1>
                </div>
                <div class="level-item" v-if="showDatUserWhoView">
                    <div v-html="datUserWhoView" ></div>
                </div>
            </div>
            <div class="level-right">
                <div class="level-item">
                </div>
            </div>
        </nav>
    </div>
</template>

<script>
    export default {
        name: "TitlePlus",
        props:{
            titleDisplay : String,
            datUserWhoView : String,
            plus : Boolean ,
            visible : {
                type: Boolean,
                default: true
            },
            iconToShow : String,
            showIcon :{
                type: Boolean,
                default: true
            },
            showDatUserWhoView :{
                type: Boolean,
                default: true
            },
            showTitleDisplay :{
                type: Boolean,
                default: true
            }
        },
        computed:{
            getColorTitle(){
                if(!this.visible){
                    return 'color: #8C8F9E'
                }
                return  this.plus  ? 'color: #C10015' : 'color: #167df0 '
            },
            addTitleDisable: function () {
                if(!this.visible){
                    return this.DISABLED
                }else{
                    return ''
                }
            }
        },
        data(){
            return{
                // DISABLED : 'Disabled'
                DISABLED : '',
                // iconIfNotPlus : `file-document`
            }
        }

    }
</script>

<style scoped>

</style>